// 保存token
export function saveToken(key,token) {
    window.localStorage.setItem(key, token)
}
// 获取token
export function getToken(key) {
    return window.localStorage.getItem(key)
}
// 删除token
export function removeToken(key) {
    window.localStorage.removeItem(key)
}